import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { SUBSCRIPTION_DETAIL } from "../../../../services/ApiCalls";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../../components/Common/Loader";
import { checkResponse } from "../../../../utilities/utilities";
import SubscriptionForm from "./SubscriptionForm";

const SubscriptionAdd = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState();
  console.log(data, "datadata");

  const [getLoader, setGetLoader] = useState(true);
  useEffect(() => {
    if (id) {
      getSubscription(id);
    } else {
      setGetLoader(false);
    }
  }, [id]);

  const getSubscription = async (id) => {
    try {
      const res = await SUBSCRIPTION_DETAIL(id);
      checkResponse({
        res,
        setData: (data) => {
          setData(data || null);
          const subscription = data;
          console.log(subscription, "response data=====<>");
        },
        setLoader: setGetLoader,
      });
    } catch (error) {
      setGetLoader(false);
      console.error("Error fetching subscription:", error);
    }
  };
  return (
    <>
      {getLoader && <Loader />}
      <section className="addStudent position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center justify-content-between gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <Link to={"/subscription"} className="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="18"
                      viewBox="0 0 14 24"
                      fill="none"
                    >
                      <path
                        d="M13.2085 3.03579L4.33158 11.9032L13.2085 20.7706C13.5449 21.1067 13.7339 21.5624 13.7339 22.0376C13.7339 22.5128 13.5449 22.9686 13.2085 23.3046C12.8721 23.6406 12.4159 23.8294 11.9402 23.8294C11.4645 23.8294 11.0082 23.6406 10.6718 23.3046L0.527997 13.1702C0.360568 13.0043 0.227702 12.807 0.137077 12.5895C0.0464509 12.372 -0.000138658 12.1388 3.09972e-07 11.9032C3.09972e-07 11.4288 0.189391 10.9716 0.525128 10.6362L10.6704 0.503263C11.0086 0.176822 11.4615 -0.0038851 11.9318 6.33701e-05C12.402 0.00401184 12.8519 0.192299 13.1845 0.524373C13.5171 0.856446 13.7059 1.30574 13.7101 1.77547C13.7143 2.24521 13.5337 2.69781 13.2071 3.03579H13.2085Z"
                        fill="black"
                      />
                    </svg>
                  </Link>
                  <h4 className="mb-0 py-3 fw-bold text-capitalize">
                    {!id ? "Add Subscription Plan" : "Edit Subscription Plan"}
                  </h4>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white py-5">
                {!getLoader && <SubscriptionForm data={data} />}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SubscriptionAdd;
